import { ModelsState } from 'src_common/common/websocket2/ModelsState';
import { AppUpdateVersionState } from './AppUpdateVersion/AppUpdateVersion';
import { CasinoMobileVersionState } from './CasinoMobileVersion/CasinoMobileVersionState';
import { EventDetailsState } from './EventDetailsState/EventDetailsState';
import { QuickLinkTrayState } from './QuickLinkTrayState/QuickLinkTrayState';
import { SpecialSportsState } from './SpecialSportsState/SpecialSportsState';
import { SdkStaff } from 'src/AppState/sdk/staff';
import { PromotedEventsState } from './PromotedEventsState/PromotedEventsState';
import { TopEventsEventsState } from './TopEventsState/TopEventsState';
import { CmsTranslationsState } from './CmsTranslationsState/CmsTranslationsState';
import { LanguagesState } from './LanguagesState/LanguagesState';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';
import { CmsDisplayOrderState } from './CmsDisplayOrderState/CmsDisplayOrderState';
import { TrpcClient } from 'src/AppState/TrpcClient';
import { QuickLinkTrayV2State } from './QuickLinkTrayState/QuickLinkTrayV2State';

export class CmsState {
    public readonly appUpdateVersionState: AppUpdateVersionState;
    public readonly casinoMobileVersionState: CasinoMobileVersionState;
    public readonly cmsDisplayOrderState: CmsDisplayOrderState;
    public readonly cmsTranslations: CmsTranslationsState;
    public readonly eventDetails: EventDetailsState;
    public readonly languagesState: LanguagesState;
    public readonly promotedEventsState: PromotedEventsState;
    public readonly topEventsState: TopEventsEventsState;
    public readonly specialSportsState: SpecialSportsState;
    public readonly quickLinkTrayState: QuickLinkTrayState;
    public readonly quickLinkTrayV2State: QuickLinkTrayV2State;

    public constructor(configState: ConfigState, modelsState: ModelsState, sdkStaff: SdkStaff, trpcClient: TrpcClient) {
        this.appUpdateVersionState = new AppUpdateVersionState();
        this.casinoMobileVersionState = new CasinoMobileVersionState();
        this.cmsDisplayOrderState = new CmsDisplayOrderState();
        this.cmsTranslations = new CmsTranslationsState();
        this.eventDetails = new EventDetailsState(modelsState);
        this.languagesState = new LanguagesState(configState);
        this.promotedEventsState = new PromotedEventsState(trpcClient);
        this.topEventsState = new TopEventsEventsState(trpcClient);
        this.specialSportsState = new SpecialSportsState(modelsState, sdkStaff);
        this.quickLinkTrayState = new QuickLinkTrayState(sdkStaff);
        this.quickLinkTrayV2State = new QuickLinkTrayV2State(sdkStaff);
    }
}
